<div>

    <div class="mb-6">
        <div class="mb-2 font-medium title requiredValue">Follow-Up Mode <span class="text-red-500">*</span></div>
        <p-select [options]="followupOptions" [(ngModel)]="selectedFollowup" placeholder="Select Mode"
            class="w-full profile-select" required />
    </div>

    <div class="mb-6">
        <div class="mb-2 font-medium title requiredValue">Follow Up Action <span class="text-red-500">*</span></div>
        <input type="text" pInputText [(ngModel)]="nextFollowUp" class="w-full profile-input" style="box-shadow: none;" required />
    </div>

    <div class="mb-6">
        <div class="mb-2 font-medium title ">Remark</div>
        <textarea rows="5" cols="30" class="w-full profile-input" pTextarea [(ngModel)]="remarks"></textarea>
    </div>

    <div class="mb-6">
        <div class="mb-2 font-medium title requiredValue">Follow Up Date <span class="text-red-500">*</span></div>
        <p-datepicker [showIcon]="true" [iconDisplay]="'input'" [minDate]="minReminderDate" [style]="{'width':'100%'}" [(ngModel)]="followupDate" class="w-full" appendTo="body" required />
    </div>

    <div class="flex items-center mb-6">
        <label for="ingredient1" class="mr-3 font-medium ml-1 title"> Set Reminder </label>
        <p-checkbox inputId="ingredient1" name="reminder" [binary]="true" [(ngModel)]="isSetReminder" />
    </div>


    <div class="flex justify-end">
        <p-button label="Add Follow Up" 
        [loading]="loading"
        [disabled]="loading"
        icon="pi pi-plus" (click)="submitForm()"
            class="w-full mt-8 flex justify-end"></p-button>
    </div>
</div>